export default __webpack_public_path__ + "static/media/surveyLogo.1eabf3f5.svg";